import 'typings.d';

export const environment = {
  firebase: window.env.firebaseClientConfig,
  production: true,
  wagerApi: window.env.wagerApi,
  walletApi: window.env.walletApi,
  build: 24,
  version: '1.5.5',
  deployment: window.env.deployment,
};
